import React from 'react';
import Heading from '../../Typography/Heading/Heading.mjs';
import VideoControlIconButton from '../VideoControlIconButton/VideoControlIconButton.mjs';
import { StyledContainer, StyledImage, StyledOverlay, StyledHeadingContainer } from './VideoHeroCard.styles.mjs';

const VideoHeroCard = ({ src, alt, heading, onClick }) => (React.createElement(StyledContainer, { onClick: onClick },
    src && React.createElement(StyledImage, { src: src, alt: alt }),
    React.createElement(StyledOverlay, null),
    React.createElement(VideoControlIconButton, { iconType: "play", variant: "primary", className: "overlay-play-button" }),
    heading && (React.createElement(StyledHeadingContainer, null,
        React.createElement(Heading, { tag: "h4" }, heading)))));

export { VideoHeroCard as default };
//# sourceMappingURL=VideoHeroCard.mjs.map
